import React, { useState } from 'react';
import { ChevronDown, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const FAQ = () => {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);

  const leftItems = t.faq.items.filter((_, i) => i % 2 === 0);
  const rightItems = t.faq.items.filter((_, i) => i % 2 === 1);

  const renderItem = (faq, index) => (
    <div
      key={faq.q}
      className="border border-line overflow-hidden transition-all hover:border-teal/30 bg-surface"
      style={{ borderRadius: '12px' }}
    >
      <button
        type="button"
        onClick={() => setOpenIndex(openIndex === index ? null : index)}
        className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-sand/50 transition-colors gap-4"
      >
        <span className="text-sm font-semibold text-ink">{faq.q}</span>
        <ChevronDown
          className={`w-5 h-5 text-teal shrink-0 transition-transform duration-300 ${
            openIndex === index ? 'rotate-180' : ''
          }`}
        />
      </button>
      {openIndex === index && (
        <div className="px-5 py-4 bg-sand/40 border-t border-line">
          <p className="text-muted leading-relaxed text-sm">{faq.a}</p>
        </div>
      )}
    </div>
  );

  return (
    <section id="faq" className="py-24 bg-surface">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14 max-w-xl mx-auto">
          <span className="text-teal text-sm font-bold uppercase tracking-[0.18em]">{t.faq.kicker}</span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-ink font-heading">
            {t.faq.title}{' '}
            <span className="font-accent italic text-teal font-normal">{t.faq.titleAccent}</span>
          </h2>
          <p className="mt-4 text-muted">{t.faq.intro}</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-4 lg:gap-6">
          <div className="space-y-4">
            {leftItems.map((faq) => {
              const index = t.faq.items.indexOf(faq);
              return renderItem(faq, index);
            })}
          </div>
          <div className="space-y-4">
            {rightItems.map((faq) => {
              const index = t.faq.items.indexOf(faq);
              return renderItem(faq, index);
            })}
          </div>
        </div>

        <div
          id="contact"
          className="mt-16 bg-teal/5 border border-teal/15 p-8 lg:p-10 text-center"
          style={{ borderRadius: '1.25rem' }}
        >
          <h3 className="text-xl font-bold text-ink mb-2">{t.faq.contactTitle}</h3>
          <p className="text-muted mb-6 text-sm">{t.faq.contactLead}</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a
              href={`mailto:${t.faq.email}`}
              className="flex items-center justify-center gap-2 bg-surface border border-line hover:border-teal/40 text-teal px-6 py-3 text-sm font-semibold transition-all"
              style={{ borderRadius: '12px' }}
            >
              <Mail className="w-4 h-4" />
              {t.faq.email}
            </a>
            <a
              href="/s"
              className="flex items-center justify-center gap-2 bg-coral hover:bg-coral-light text-white px-6 py-3 text-sm font-semibold transition-all"
              style={{ borderRadius: '12px' }}
            >
              {t.headerCta}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
